export default function PHP_ftp_get_option() {
  return (
    <div>
      <h1>PHP_ftp_get_option</h1>
    </div>
  );
}
